import { FeedComponentDefaultGroup } from "@strtmn/sds/schemas"
import type { FeedComponentDto, FeedComponentGroup } from "@strtmn/sds/types"

/**
 * Groups offered in the create/edit dropdown, with their German label.
 * @see FeedComponentGroups in @strtmn/sds for the full ATLAS taxonomy,
 * most of which isn't offered here yet.
 */
export const FEED_COMPONENT_GROUP_OPTIONS: {
  value: FeedComponentGroup
  label: string
}[] = [
  { value: "miscellaneous", label: "Sonstiges" },
  { value: "grass_silage", label: "Gras" },
  { value: "corn_silage", label: "Mais" },
  { value: "leftovers", label: "Restfutter" },
  { value: "premix", label: "Vormischung" },
  { value: "water", label: "Wasser" },
  { value: "mineral", label: "Mineralfutter" },
  { value: "concentrate", label: "Kraftfutter" },
]

/**
 * German label for a feed component group. `null`/`undefined` (all existing
 * rows, predating this field's UI) are treated as the default group. Falls
 * back to the raw value for ATLAS groups not (yet) in
 * FEED_COMPONENT_GROUP_OPTIONS.
 */
export const getFeedComponentGroupLabel = (
  group: string | null | undefined
): string => {
  const resolvedGroup = group || FeedComponentDefaultGroup
  return (
    FEED_COMPONENT_GROUP_OPTIONS.find((opt) => opt.value === resolvedGroup)
      ?.label ?? resolvedGroup
  )
}

/**
 * Takes a filename, or an ImageId of the form `${Title}#${Filename}`, and returns the path to the image.
 * @param filenameOrImageId
 */
export const getImagePath = (filenameOrImageId: string) => {
  let imageFilename = filenameOrImageId.includes("#")
    ? filenameOrImageId.split("#")[1]
    : filenameOrImageId
  return `/images/fc/${imageFilename}`
}

/**
 * Always returns the "unknown" placeholder image.
 * @param filenameOrImageId
 */
const getFallbackImagePath = (/*id: string*/) => {
  return getImagePath("unknown.png")
}

export const ensureImagePath = (
  feedComponent: FeedComponentDto,
  imageSrc: string,
  setImageSrc: React.Dispatch<React.SetStateAction<string>>
) => {
  if (!imageSrc) {
    if (feedComponent.image) {
      console.debug("Using image from feedcomponent")
      setImageSrc(getImagePath(feedComponent.image))
    } else {
      console.log("❌ Using some form of image fallback")
      setImageSrc(getFallbackImagePath(/*feedComponent.id*/))
    }
  }
}
